import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContactSearchHit from '../contactSearch/ContactSearchHit';

class SearchResults extends Component {
  
  render() {
    return (
      <div className="search-results">
        {this.props.hits.map(hit => {
          return !hit.isContact ? (
            <a className="search-result" href={hit.url} key={hit.id}>
              <div className="search-result__category">{hit.typeName}</div>
              <h2 className="h4 search-result__title">{hit.title}</h2>
              <p className="search-result__description" dangerouslySetInnerHTML={{
                __html: hit.excerpt
              }}></p>
            </a>
          ) : (<ContactSearchHit key={hit.id} hit={hit} translations={this.props.contactTranslations} />);
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hits: state.searchResults.hits,
    contactTranslations: state.contactTranslations,
  };
}

export default connect(mapStateToProps)(SearchResults);
